import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

type NewsroomDismissAlertDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export function NewsroomDismissAlertDialog({
  open,
  onOpenChange,
  onConfirm,
}: NewsroomDismissAlertDialogProps) {
  const { t } = useTranslation('regulatory-alerts')

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('inbox.dismissConfirmTitle')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('inbox.dismissConfirmDescription')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('inbox.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              void onConfirm()
            }}
          >
            {t('inbox.dismissConfirmAction')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
